import React from "react";
import { Relative } from "../../../BuildingBlocks/Relative";
import { Padding } from "../../../BuildingBlocks/Padding";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { Background } from "../../../BuildingBlocks/Background";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FontQuicksand } from "../../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../../BuildingBlocks/FontSize";
import { TextColor } from "../../../BuildingBlocks/TextColor";
import { FrontColors } from "../../../../models/FrontColors";
import { WeightMedium } from "../../../WeightMedium/WeightMedium";
import { Width } from "../../../BuildingBlocks/Width";
import { useHover } from "../../../../hooks/useHover";
import { Absolute } from "../../../BuildingBlocks/Absolute";
import { Image } from "../../../BuildingBlocks/Image";
import { TPixelSize } from "../../../../models/StringLiterals";

type TGuideDesktopProps = {
    imageUrl: string;
    href: string;
    blurb: string;
    width?: TPixelSize;
    imageHeight?: TPixelSize;
}

export const FPGuideDesktop = (props: React.PropsWithChildren<TGuideDesktopProps>): JSX.Element => {
    const [ref, isHovering] = useHover<HTMLDivElement>({});

    return (
        <Width width={props.width || "250px"}>
            <a
                href={props.href}
                target="_blank"
            >
                <Relative divRef={ref}>
                    <Relative zIndex={2}>
                        <Padding spacing={FrontSpacing.SMALL_3}>
                            <SpacingColumn spacing={FrontSpacing.SMALL_3}>
                                {/* IMAGE */}
                                <Image 
                                    url={props.imageUrl} 
                                    borderRadius="10px" 
                                    height={props.imageHeight || "160px"}
                                    width="100%" 
                                />

                                {/* BLURB */}
                                <Blurb blurb={props.blurb} />
                            </SpacingColumn>
                        </Padding>
                    </Relative>

                    {/* HOVER */}
                    {isHovering &&
                        <Hover />
                    }
                </Relative>
            </a>
        </Width>
    );
};

const Blurb = (props: {blurb: string}): JSX.Element => (
    <FontQuicksand>
        <FontSize
            size="17px"
            lineHeight="1.5"
        >
            <TextColor color={FrontColors.NEUTRAL_18}>
                <WeightMedium>
                    {props.blurb}
                </WeightMedium>
            </TextColor>
        </FontSize>
    </FontQuicksand>
);

const Hover = (): JSX.Element => (
    <Absolute
        top="0px"
        left="0px"
        width="100%"
        height="100%"
        zIndex={1}
    >
        <Background
            borderRadius="8px"
            color={FrontColors.PROBATE_4}
            width="100%"
            height="100%"
        />
    </Absolute>
);
